import { ICoords, IBaseShape, ItemType, IBaseShapeConfig } from "@dhx/ts-diagram";
import { BaseItem } from "../BaseItem";

export class BaseShape extends BaseItem implements IBaseShape {
	constructor(config: IBaseShapeConfig, params?) {
		super(config, params);

		if (config.width) {
			config.width = parseFloat(config.width as any);
		}
		if (config.height) {
			config.height = parseFloat(config.height as any);
		}
		if (config.x) {
			config.x = parseFloat(config.x as any);
		}
		if (config.y) {
			config.y = parseFloat(config.y as any);
		}
		if (config.strokeWidth) {
			config.strokeWidth = parseFloat(config.strokeWidth as any);
		}
	}
	public getBaseType(): ItemType {
		return "shape";
	}
	public getCenter(): ICoords {
		const config = this.config;
		return {
			x: Math.abs(config.width / 2),
			y: Math.abs(config.height / 2),
		};
	}
	public getPoint(x: number, y: number): ICoords {
		const config = this.config;
		if (config.angle) {
			const cx = config.x + config.width / 2;
			const cy = config.y + config.height / 2;
			const angleRad = config.angle * (Math.PI / 180);
			return {
				x: (x - cx) * Math.cos(angleRad) - (y - cy) * Math.sin(angleRad) + cx,
				y: (x - cx) * Math.sin(angleRad) + (y - cy) * Math.cos(angleRad) + cy,
			};
		}
		return { x, y };
	}
}
